import { render, staticRenderFns } from "./BuyerNav.vue?vue&type=template&id=b13be1c0&"
import script from "./BuyerNav.vue?vue&type=script&lang=js&"
export * from "./BuyerNav.vue?vue&type=script&lang=js&"
import style0 from "./BuyerNav.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports